videoroomClient.directive('videoroomClient', [
    'templateCache',
    '$parse',
    'helperService',
    function (templateCache, $parse, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'videoroom_client/templates/' + helperService.getRedesignPathPrefix() + 'videoroomClient.html'
            )
        };
    }
]);
